import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import MODALS from '../../../modals/constants/modals';
import { modalsActions } from '../../../modals/actions';
import styles from './BeforeAfterDesktop.module.sass';
import './SlickOverrides.sass';
import SliderArrows from '../../../ui_kit/slider_arrows/SliderArrows';
import BeforeAfterImage1 from '../../../../images/pages/balancing_clearing_serum/before_after_desktop/img1.png';
import BeforeAfterImage2 from '../../../../images/pages/balancing_clearing_serum/before_after_desktop/img2.png';
import BeforeAfterImage3 from '../../../../images/pages/balancing_clearing_serum/before_after_desktop/img3.png';
import BeforeAfterImage4 from '../../../../images/pages/balancing_clearing_serum/before_after_desktop/img4.png';
import BeforeAfterImage5 from '../../../../images/pages/balancing_clearing_serum/before_after_desktop/img5.png';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';

class BeforeAfterDesktop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidePrevSliderArrow: true,
      hideNextSliderArrow: false,
    };
  }

  onImageClick = (images, index) => {
    const { openImagesSliderModal } = this.props;
    openImagesSliderModal(images, index);
  };

  onPrevClick = () => {
    this.slider.slickPrev();
  };

  onNextClick = () => {
    this.slider.slickNext();
  };

  render() {
    const { hidePrevSliderArrow, hideNextSliderArrow } = this.state;
    const images = [
      BeforeAfterImage1, BeforeAfterImage2, BeforeAfterImage3, BeforeAfterImage4, BeforeAfterImage5,
    ];
    const sliderImages = images.map((image) => (
      { url: image.src }
    ));
    return (
      <div className={styles['before-after-desktop']}>
        <div className={styles.content}>
          <div className="before-after-slider">
            <div className={styles.feed}>
              <Slider
                ref={(slider) => {
                  this.slider = slider;
                }}
                dots={false}
                infinite={false}
                arrows={false}
                speed={500}
                slidesToShow={2}
                slidesToScroll={1}
                beforeChange={(_oldIndex, newIndex) => {
                  this.setState({
                    hidePrevSliderArrow: newIndex === 0,
                    hideNextSliderArrow: newIndex === sliderImages.length - 2,
                  });
                }}
              >
                {images.map((image, index) => (
                  <ClickableDiv
                    onClick={() => this.onImageClick(sliderImages, index)}
                    key={image.placeholder}
                    className={styles['image-wrapper']}
                  >
                    <img
                      className="lazyload blur"
                      src={image.placeholder}
                      data-src={image}
                      alt="before/after"
                    />
                  </ClickableDiv>
                ))}
              </Slider>
            </div>
          </div>
        </div>
        <SliderArrows
          onNextClick={this.onNextClick}
          onPrevClick={this.onPrevClick}
          hidePrevArrow={hidePrevSliderArrow}
          hideNextArrow={hideNextSliderArrow}
        />
      </div>
    );
  }
}

BeforeAfterDesktop.propTypes = {
  openImagesSliderModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  openImagesSliderModal: (images, activeImageId) => dispatch(modalsActions.openModalRequest({
    modal: MODALS.IMAGES_SLIDER,
    data: { images, activeImageId },
  })),
});

export default connect(null, mapDispatchToProps)(BeforeAfterDesktop);
